(function () {
  'use strict';
  if (window.__PW_THIRD_PARTY_LOADER__) return;
  window.__PW_THIRD_PARTY_LOADER__ = true;

  var loaded = Object.create(null);
  var interacted = false;

  function scriptExists(fragment) {
    return !!document.querySelector('script[src*="' + fragment + '"]');
  }

  function loadScript(key, source, options) {
    if (loaded[key]) return loaded[key];
    if (scriptExists(source.split('/').slice(2).join('/'))) {
      loaded[key] = Promise.resolve();
      return loaded[key];
    }

    loaded[key] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = source;
      script.async = true;
      if (options && options.id) script.id = options.id;
      if (options && options.type) script.type = options.type;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return loaded[key];
  }

  function loadClarityFallback() {
    if (window.clarity || scriptExists('clarity.ms/tag/')) return;
    loadScript('clarity', 'https://www.clarity.ms/tag/npn40s11ar').catch(function () {});
  }

  function loadMerchantWidget() {
    if (window.merchantwidget || scriptExists('merchantwidget.js')) return;
    loadScript('merchant', 'https://www.gstatic.com/shopping/merchant/merchantwidget.js', {
      id: 'merchantWidgetScript'
    }).then(function () {
      if (window.merchantwidget && typeof window.merchantwidget.start === 'function') {
        window.merchantwidget.start({ position: 'LEFT_BOTTOM' });
      }
    }).catch(function () {});
  }

  function schedule(callback, delay) {
    window.setTimeout(function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 2500 });
      } else {
        callback();
      }
    }, delay);
  }

  function scheduleAfterInteraction() {
    if (interacted) return;
    interacted = true;
    schedule(loadClarityFallback, 800);
    schedule(loadMerchantWidget, 1800);
  }

  ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (eventName) {
    window.addEventListener(eventName, scheduleAfterInteraction, { once: true, passive: true });
  });

  schedule(loadClarityFallback, 6000);
  schedule(loadMerchantWidget, 8500);
})();
